var map = {
	"./gc_classic.png": 302,
	"./gc_eyes.png": 303,
	"./gc_microdermabrasion.png": 304,
	"./gc_monetary.png": 305,
	"./gc_neck.png": 306,
	"./gc_peeling.png": 307,
	"./gc_personalized.png": 308,
	"./gc_specific.png": 309
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc ^\.\/.*$
// module id = 811
// module chunks = 1